import BranchesFilters from './branches-filters';

export default BranchesFilters;
